<!-- splash screen -->
<div #splashScreen class="splash-screen">
	<img src="./assets/media/logos/one-channel-logo-dark.png" alt="Logo" />
	<mat-spinner diameter="40"></mat-spinner>
</div>
